import type { NpcAttackGeometry } from "@frontier/content/combat-rules";
import type { NpcAttackKind } from "@frontier/content/npcs";
import type { Point } from "./geometry";

interface AttackState extends Point {
  attackGeometry?: NpcAttackGeometry;
  attackKind: NpcAttackKind;
  attackX: number;
  attackY: number;
}
export function npcAttackGeometry(state: AttackState): {
  endpoint: Point;
  radius: number;
} {
  const dx = state.attackX - state.x;
  const dy = state.attackY - state.y;
  const distance = Math.hypot(dx, dy);
  const length =
    state.attackKind === "charge"
      ? Math.min(
          distance,
          state.attackGeometry?.chargeDistance ?? 0,
        )
      : distance;
  return {
    endpoint: {
      x: state.x + (distance > 0 ? (dx / distance) * length : 0),
      y: state.y + (distance > 0 ? (dy / distance) * length : 0),
    },
    radius:
      state.attackKind === "barrage" ? state.attackGeometry?.barrageRadius ?? 0 : 0,
  };
}

export function npcAttackVisible(
  state: {
    dead: boolean;
    docked: boolean;
    attackKind: NpcAttackKind;
    telegraph: number;
  },
  elapsedSeconds: number,
): boolean {
  return (
    !state.dead &&
    !state.docked &&
    state.attackKind !== "none" &&
    (state.attackKind === "repair"
      ? elapsedSeconds <= 0.25
      : state.telegraph > elapsedSeconds)
  );
}

export function bossFlakFan(
  state: AttackState & { archetype: string },
): { angle: number; halfAngle: number; range: number } | undefined {
  if (state.archetype !== "boss" || state.attackKind !== "shot" || !state.attackGeometry)
    return undefined;
  return {
    angle: Math.atan2(state.attackY - state.y, state.attackX - state.x),
    halfAngle: state.attackGeometry.flakHalfAngle,
    range: state.attackGeometry.flakRange,
  };
}
